import React from 'react';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import useThumbnailUrl from '../../hooks/useThumbnailUrl';
import { useSetRecoilState } from 'recoil';
import { otpModalState } from '../../recoil/otp/otpModalAtom';

const VideoCard = ({ item, isLogin }) => {
  const navigate = useNavigate();
  const imageUrl = useThumbnailUrl(item.thumbnail_info, 296);
  const setOtpLogin = useSetRecoilState(otpModalState);

  // 단순 로그인 확인용

  const moveProductVideoDetailPage = (id) => {
    navigate(`/product-video-detail/${id}`);
  };

  const moveClipPage = (id) => {
    if (!isLogin) {
      setOtpLogin(true);
      return;
    }
    navigate(`/video-clip-detail/${id}`);
  };

  const moveLiveClipPage = (clipmetaid, live_clip_id) => {
    if (!isLogin) {
      setOtpLogin(true);
      return;
    }
    navigate(`/video-live-detail/${clipmetaid}?clip_live_id=${live_clip_id}`);
  };

  const movePage = () => {
    // 일반 클립
    if (item?.is_free && item.is_replay) {
      moveClipPage(item.clipmetaid);
      // 라이브 클립
    } else if (item?.is_free && !item.is_replay && item.live_clip_id) {
      moveLiveClipPage(item.clipmetaid, item.live_clip_id);
    } else {
      moveProductVideoDetailPage(item.id);
    }
  };

  return (
    <div className={'product-card video-card'}>
      <figure className='product-card-img-group cursor-pointer' onClick={movePage}>
        <img
          fetchpriority='high'
          src={imageUrl || '/img_no_img.png'}
          alt='video thumbnail'
          className={'product-card-img'}
          width='293.5'
          height='164.5'
          onError={(e) => {
            e.target.onerror = null; // onError 이미지도 실패했을 때 무한루프 방지
            e.target.src = '/img_no_img.png';
          }}
          decoding={'async'}
        />
      </figure>
      <div className='product-card-txt-group'>
        <h3 className={'product-card-title cursor-pointer'} onClick={movePage}>
          {item.title}
        </h3>
        <div className={'product-card-info-group'}>
          <span className={'info-txt'}>{dayjs(item.start_at).format('YYYY.MM.DD')}</span>
        </div>
      </div>
    </div>
  );
};

export default VideoCard;
